import { createContext } from "react";

/**
 * Context that allows to store user data
 * In all components
 *
 * It may be compared to global storage
 */
export default createContext(null);
